module.exports = __webpack_public_path__ + "img/78.c3e33ca6.jpg";